/* eslint-disable global-require */
module.exports = [
  ...require('./Alert/i18n'),
  ...require('../search/i18n'),
  ...require('./Preferences/i18n'),
  ...require('./ModalTour/i18n'),
  ...require('./LoginModal/i18n'),
  ...require('./LoginOrRegistrationModal/i18n'),
];
